import { IUserProfile } from "@/interfaces/Data/User/IUserProfile";
import { RootState } from "@/redux/store";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

let initialProfile: IUserProfile | null | undefined;

export const userSlice = createSlice({
  name: "user",
  initialState: {
    profile: initialProfile,
  },
  reducers: {
    setUserProfile(state, action: PayloadAction<IUserProfile | null>) {
      state.profile = action.payload;
    },
    setUserName(state, action: PayloadAction<string>) {
      if (state.profile) {
        state.profile.name = action.payload;
      }
    }
  },
});

export const { setUserProfile, setUserName } = userSlice.actions;

export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
